// extracted by mini-css-extract-plugin
export default {"tabs_container":"tabs_tabs_container__nPCR9","tabs":"tabs_tabs__VTKaO","tab":"tabs_tab__LXPA5","active":"tabs_active__FyvvP"};